import { Button } from "../Button";
import { Trash } from "../Icons";
import { isNil, noop } from "lodash";
import {
  ConfirmationModal,
  useConfirmationModal,
} from "../Portals/ConfirmationModal/ConfirmationModal";

export const ConfirmableDeleteButton = ({
  name,
  onConfirm,
  onCancel = noop,
  onOpen = noop,
  modalProps: propModalProps = {},
  buttonProps = {},
  children = <Trash />,
  confirmationDisabled = false,
  description,
  subDescription,
}) => {
  const { portalProps, openModal, ...hookModalProps } = useConfirmationModal();

  return (
    <>
      {!confirmationDisabled && (
        <ConfirmationModal
          portalProps={portalProps}
          description={
            description ||
            `This is a non-reversible action. Are you sure you want to permanently delete ${!isNil(name) ? `"${name}"` : "this"}?`
          }
          subDescription={
            subDescription || "Holding Shift while deleting the item will prevent this modal from appearing"
          }
          cancelText="Cancel"
          continueText="Delete"
          onConfirm={onConfirm}
          {...hookModalProps}
          {...propModalProps}
        />
      )}
      <Button
        onClick={async (e) => {
          if (confirmationDisabled || e.shiftKey) {
            return onConfirm(e);
          }

          onOpen(e);
          const res = await openModal();

          if (res) {
            onConfirm(e);
          } else {
            onCancel(e);
          }
        }}
        title={!isNil(name) ? `Delete ${name}` : "Delete"}
        {...buttonProps}
      >
        {children}
      </Button>
    </>
  );
};
